import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FillContainerDirective } from './fill-container.directive';

@NgModule({
  declarations: [FillContainerDirective],
  imports: [CommonModule],
  exports: [FillContainerDirective],
})
export class FillContainerModule {}
